<div class="confirm-dialog-container">
  <h2 mat-dialog-title>
    <mat-icon color="warn" class="dialog-icon">warning</mat-icon>
    {{ data.title }}
  </h2>
  
  <mat-dialog-content>
    <p>{{ data.message }}</p>
    <p class="warning-text">Diese Aktion kann nicht rückgängig gemacht werden.</p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    <button mat-raised-button color="warn" (click)="onConfirm()">
      <mat-icon>delete</mat-icon>
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
